export const SECTION_IDS = {
    DESCRIPTION_SECTION_ID: 'description',
    ENTITY_SECTION_ID: 'entity_section',
    DISTANCES_SECTION_ID: 'distances',
    CONTACT_SECTION_ID: 'contact',
    RATING_REVIEWS_SECTION_ID: 'ratings',
    AVAILABILITY_SECTION_ID: 'availability',
    PRICE_SECTION_ID: 'price',
    SIDEBAR_SECTION_ID: 'sidebar',
    FOOTER: 'footer',
}

export const STICKY_FOOTER_SCROLL_THRESHOLD = 300

export enum PdpToCheckoutPosition {
    GALLERY = 'gallery',
    GALLERY_FOOTER = 'gallery_footer',
    STICKY_FOOTER = 'sticky_footer',
    ENQUIRY_POPUP = 'enquiry_popup',
    CONTACT_BUTTON = 'contact_button',
    CONTENT = 'content',
    PRICE_WIDGET = 'price_widget',
    SIDEBAR = 'sidebar',
    COMBO_LISTING_POPUP = 'combo_listing_popup',
}

export enum VirtualTourPosition {
    PDP_GALLERY = 'pdp_gallery',
    GRID_CARD = 'grid_card',
    OBJECT_CARD = 'object_card',
}

export const NAVBAR_HEIGHT = 80

export enum EntitySectionPosition {
    COMBO_LISTING_ENTITY_SECTION = 'combo_listing_entity_section',
    COMBO_LISTING_POPUP = 'combo_listing_popup',
}

export enum EntitySectionConstant {
    POPUP_OBJECT_WIDTH = 296,
    POPUP_OBEJCT_GAP = 8,
    UNIT_PER_PAGE = 4,
}
